import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { DateMaker } from '../../lib/helpers';
import { WarningIcon } from './WarningIcon.jsx';

const TitleText = styled.div`
  align-items: center;
  color: #5a5a5a;
  display: flex;
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 500;
  letter-spacing: normal;
  line-height: normal;
`;

export const TileDigestTitle = ({ bucketDate }) => (
  <TitleText>
    {DateMaker.parsePlanned(bucketDate)}
    {DateMaker.isPastOrLastDay(bucketDate) && <WarningIcon />}
  </TitleText>
);

TileDigestTitle.propTypes = {
  bucketDate: PropTypes.string.isRequired,
};
